import { AutocompleteWithLabel, CheckboxWithLabel } from '@adotel/components'
import { Fade, Typography } from '@material-ui/core'
import { FormikErrors, FormikTouched } from 'formik'
import React from 'react'

import SectionTitle from '../../components/SectionTitle'
import { getTranslate } from '../../localization'
import { Currency } from '../../types/currency'
import { RatePlanForModify, RatePlanForGenerate } from '../../types/rateplan'

interface RateplanSupportedWalletTypesProps {
  values: RatePlanForModify | RatePlanForGenerate
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  errors: FormikErrors<RatePlanForModify | RatePlanForGenerate>
  touched: FormikTouched<RatePlanForModify | RatePlanForGenerate>
  handleBlur: any
  isSubmitting: any
  classes: any
  options: { currency: Currency; walletType: string | null }[]
  supportedWalletTypes: { label: string; value: string }[]
  loading?: boolean
  isPhysical: boolean
}

export const RateplanSupportedWalletTypes: React.FC<
  RateplanSupportedWalletTypesProps
> = ({
  values,
  setFieldValue,
  errors,
  touched,
  options,
  supportedWalletTypes,
  classes,
  loading,
  isPhysical
}) => {
  return (
    <>
      <SectionTitle title="Wallet Types" marginBottom />
      <Typography className={classes.paragraph}>
        {getTranslate(
          'Select Currencies and then choose supported wallet types for that currency'
        )}
        :
      </Typography>
      <Fade in timeout={600}>
        <div className={classes.fieldsContainer}>
          {options.map((item, index) => {
            return (
              <React.Fragment key={item.currency}>
                <CheckboxWithLabel
                  placeholder={item.currency}
                  checked={
                    values.supportedWalletTypes?.some(
                      (ele) => ele.currency === item.currency && ele.isSelected
                    ) ?? false
                  }
                  onChange={(event) => {
                    setFieldValue(
                      `supportedWalletTypes[${index}].isSelected`,
                      event.currentTarget.checked
                    )
                    setFieldValue(
                      `supportedWalletTypes[${index}].currency`,
                      item.currency
                    )
                  }}
                  inputSize="small"
                  disabled={!isPhysical}
                />
                <AutocompleteWithLabel
                  label={`${getTranslate('Wallet Types for')} ${item.currency}`}
                  placeholder={`${getTranslate('Wallet Types for')} ${
                    item.currency
                  }`}
                  multiple
                  onChange={(event, value) => {
                    setFieldValue(
                      `supportedWalletTypes[${index}].walletTypes`,
                      value.map((singleWalletType) => singleWalletType.value)
                    )
                  }}
                  disabled={
                    !isPhysical ||
                    !values.supportedWalletTypes?.some(
                      (ele) => ele.currency === item.currency && ele.isSelected
                    )
                  }
                  options={supportedWalletTypes}
                  value={supportedWalletTypes.filter(
                    (singleSupportedWalletType) => {
                      const swt = values.supportedWalletTypes?.find(
                        (s) => s && s.currency === item.currency
                      )
                      return swt?.walletTypes?.includes(
                        singleSupportedWalletType.value
                      )
                    }
                  )}
                  size="small"
                  error={
                    (touched.supportedWalletTypes &&
                      touched.supportedWalletTypes[index] &&
                      errors.supportedWalletTypes &&
                      !!errors.supportedWalletTypes[index]) ||
                    undefined
                  }
                  helpertext={getTranslate(
                    (touched.supportedWalletTypes &&
                      !!touched.supportedWalletTypes[index] &&
                      errors.supportedWalletTypes &&
                      errors.supportedWalletTypes[index] &&
                      (
                        errors.supportedWalletTypes[index] as {
                          supportedWalletTypes: string
                        }
                      ).supportedWalletTypes) ||
                      ''
                  )}
                  inputSize="small"
                  loading={loading}
                  loadingText={getTranslate('Loading') + '...'}
                />
                <div />
              </React.Fragment>
            )
          })}
          <div />
        </div>
      </Fade>
    </>
  )
}
